import Swal from "sweetalert2";
import * as bootstrap from "bootstrap";

export const LoadingDiv = () => {
  return (
    <div
      className="d-flex justify-content-center align-items-center position-fixed top-0 start-0 w-100 h-100"
      style={{ zIndex: 9999 }}
    >
      <div className="sk-chase sk-primary display-1">
        {[...Array(6)].map((_, i) => (
          <div key={i} className="sk-chase-dot" />
        ))}
      </div>
    </div>
  );
};
export const LoadingDivShort = () => {
  return (
    <div className="d-flex justify-content-center align-items-center py-4">
      <div
        className="spinner-border spinner-border-sm text-primary"
        role="status"
      >
        <span className="visually-hidden">Loading...</span>
      </div>
    </div>
  );
};

export const SweetAlertShow = (icon, title, text, timer = null) => {
  Swal.fire({
    icon: icon,
    title: title,
    text: text,
    timer: timer ?? 1500,
    showConfirmButton: true,
  });
  return "";
};

// export const closeModal = (modalId) => {
//   const modalEl = document.getElementById(modalId);
//   if (!modalEl) return;

//   const modal = bootstrap.Modal.getOrCreateInstance(modalEl);

//   modalEl.addEventListener(
//     "hidden.bs.modal",
//     () => {
//       // ✅ Removed the fragile .modal.show check — just always clean up
//       document.querySelectorAll(".modal-backdrop").forEach((el) => el.remove());
//       document.body.classList.remove("modal-open");
//       document.body.style.removeProperty("overflow");
//       document.body.style.removeProperty("padding-right");
//     },
//     { once: true },
//   );

//   modal.hide();
// };

// export const closeModal = (modalId) => {
//   const modalEl = document.getElementById(modalId);
//   if (!modalEl) return;

//   window.bootstrap.Modal.getOrCreateInstance(modalEl).hide();
// };



export const closeModal = (modalId) => {
  const modalEl = document.getElementById(modalId);
  if (!modalEl) return;

  const modal =
    bootstrap.Modal.getInstance(modalEl) ||
    bootstrap.Modal.getOrCreateInstance(modalEl);

  modal.hide();

  setTimeout(() => {
    document.querySelectorAll(".modal-backdrop").forEach((el) => el.remove());

    document.body.classList.remove("modal-open");
    document.body.style.removeProperty("overflow");
    document.body.style.removeProperty("padding-right");
    setTimeout(() => {
      document.querySelectorAll(".modal-backdrop").forEach((el) => el.remove());

      document.body.classList.remove("modal-open");
      document.body.style.removeProperty("overflow");
      document.body.style.removeProperty("padding-right");
    }, 50);
  }, 300);
};




export const convertNumberToWords = (amount) => {
  if (!amount) return "";
  const words = require("number-to-words");
  return words.toWords(amount).replace(/\b\w/g, (c) => c.toUpperCase());
};

export const ToastMain = Swal.mixin({
  toast: true,
  position: "bottom-end",
  showConfirmButton: false,
  timer: 2000,
  timerProgressBar: true,
  customClass: {
    container: "custom-toast-container",
  },
  didOpen: (toast) => {
    toast.onmouseenter = Swal.stopTimer;
    toast.onmouseleave = Swal.resumeTimer;
  },
});

// export const closeOffcanvas = (offcanvasId) => {
//   const offcanvasEl = document.getElementById(offcanvasId);

//   if (!offcanvasEl) return;

//   const offcanvas =
//     bootstrap.Offcanvas.getInstance(offcanvasEl) ||
//     bootstrap.Offcanvas.getOrCreateInstance(offcanvasEl);

//   offcanvas.hide();
// };
export const closeOffcanvas = (offcanvasId) => {
  const offcanvasEl = document.getElementById(offcanvasId);
  if (!offcanvasEl) return;

  window.bootstrap.Offcanvas.getOrCreateInstance(offcanvasEl).hide();
};

export const formatDate = (dateString) => {
  if (!dateString) return "-";
  const date = new Date(dateString);
  return date.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};

export const formatTime = (timeString) => {
  if (!timeString) return "-";
  const today = new Date().toISOString().split("T")[0];
  const date = new Date(`${today}T${timeString}`);

  return date.toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
};

export const formatDateTime = (dateString) => {
  if (!dateString) return "-";
  const date = new Date(dateString);

  const formatted = date
    .toLocaleString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    })
    .replace(",", "");

  return formatted.replace(/am|pm/i, (match) => match.toUpperCase());
};

export const formatDateTimeUtc = (dateString) => {
  if (!dateString) return "-";
  const date = new Date(dateString);

  const formatted = date
    .toLocaleString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
      timeZone: "UTC",
    })
    .replace(",", "");

  return formatted.replace(/am|pm/i, (match) => match.toUpperCase());
};

export const formatDateTimeToTime = (dateTime) => {
  if (!dateTime) return "-";

  const date = new Date(dateTime);

  return date.toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: true,
  });
};

export const capitalize = (str) => str.charAt(0).toUpperCase() + str.slice(1);
